var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import classNames from 'classnames';
export function Spinner(_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 'lg' : _b, _c = _a.color, color = _c === void 0 ? "primary" : _c, props = __rest(_a, ["className", "size", "color"]);
    var sizeClass = useMemo(function () {
        switch (size) {
            case "xs":
                return 'size-4';
            case 'sm':
                return 'size-5';
            case "md":
                return 'size-6';
            case 'lg':
                return 'size-8';
            case "xl":
                return 'size-10';
        }
    }, [size]);
    var colourClass = useMemo(function () {
        switch (color) {
            case "primary":
                return 'text-primary';
            case 'current':
                return 'text-current';
        }
    }, [color]);
    return (React.createElement("div", __assign({ className: classNames(colourClass, className), role: "status" }, props),
        React.createElement("svg", { "aria-hidden": "true", className: classNames(sizeClass, "color-current animate-spin"), viewBox: "0 0 58 58", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "29", cy: "29", r: "26", fill: 'none', strokeWidth: 6, className: 'stroke-gray-100' }),
            React.createElement("circle", { cx: "29", cy: "29", r: "26", fill: 'none', strokeWidth: 6, className: 'stroke-current', strokeDasharray: "4 6", pathLength: 10, strokeLinecap: "round", strokeLinejoin: "round" })),
        React.createElement("span", { className: "sr-only" }, "Loading...")));
}
